import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SettlementByContractDto } from '@models/propietarios/settlementByContractDto.model';
import { DialogGenerarLiquidacionesComponent } from '../dialog-generar-liquidaciones/dialog-generar-liquidaciones.component';

@Component({
  selector: 'app-liquidaciones',
  templateUrl: './liquidaciones.component.html',
  styleUrls: ['./liquidaciones.component.css']
})
export class LiquidacionesComponent implements OnInit {
  /** Liquidaciones generadas en esta sesión. Se llenan al cerrar el diálogo. */
  liquidacionesGeneradas: SettlementByContractDto[] = [];

  constructor(
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {

  }

  openDialogNuevaLiquidacion(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width='50%'

    const dialogRef = this.dialog.open(DialogGenerarLiquidacionesComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      // Si se cerró por backdrop no llega el array: se deja lo que ya había
      if (Array.isArray(result))
        this.liquidacionesGeneradas = result;
    });
  }
}
